// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"5bcf851b","496":"47f90339"}[chunkId] + ".chunk.js";
};